<section class="vorteile-section py-5">
    <div class="container">
        <h2 class="text-center mb-5 display-5 fw-bold">Ihre Vorteile auf einen Blick</h2>
        <div class="benefit-list d-flex flex-column gap-4">

            <!-- Maßgeschneiderte Listen -->
            <div class="benefit-card d-flex align-items-center p-4 rounded-4 shadow-sm bg-white">
                <div class="benefit-icon me-4">
                    <!-- SVG: Checklist -->
                    <svg width="48" height="48" fill="none"><rect width="48" height="48" rx="24" fill="#2563eb" fill-opacity="0.09"/><rect x="16" y="14" width="16" height="4" rx="2" fill="#2563eb"/><rect x="16" y="22" width="12" height="4" rx="2" fill="#2563eb"/><rect x="16" y="30" width="8" height="4" rx="2" fill="#2563eb"/><circle cx="10" cy="16" r="2" fill="#2563eb"/><circle cx="10" cy="24" r="2" fill="#2563eb"/><circle cx="10" cy="32" r="2" fill="#2563eb"/></svg>
                </div>
                <div>
                    <h5 class="fw-semibold mb-1">Maßgeschneiderte Listen</h5>
                    <p class="mb-0 text-secondary">Erstellen Sie individuelle Firmenlisten, die exakt auf Ihre Zielgruppe abgestimmt sind.</p>
                </div>
            </div>

            <!-- Zeitersparnis -->
            <div class="benefit-card d-flex align-items-center p-4 rounded-4 shadow-sm bg-white">
                <div class="benefit-icon me-4">
                    <!-- SVG: Stopwatch -->
                    <svg width="48" height="48" fill="none"><rect width="48" height="48" rx="24" fill="#10b981" fill-opacity="0.09"/><circle cx="24" cy="24" r="12" fill="#10b981" fill-opacity="0.16"/><path d="M24 16v8l5 3" stroke="#10b981" stroke-width="2.5" stroke-linecap="round"/></svg>
                </div>
                <div>
                    <h5 class="fw-semibold mb-1">Zeitersparnis</h5>
                    <p class="mb-0 text-secondary">Keine aufwendige Recherche mehr – alle wichtigen Informationen in einer Datei.</p>
                </div>
            </div>

            <!-- Vielseitige Anwendung -->
            <div class="benefit-card d-flex align-items-center p-4 rounded-4 shadow-sm bg-white">
                <div class="benefit-icon me-4">
                    <!-- SVG: Multiple Targets -->
                    <svg width="48" height="48" fill="none"><rect width="48" height="48" rx="24" fill="#fbbf24" fill-opacity="0.09"/><circle cx="24" cy="24" r="10" fill="#fbbf24" fill-opacity="0.16"/><circle cx="24" cy="24" r="5" fill="#fbbf24"/><circle cx="24" cy="24" r="2" fill="#fff"/></svg>
                </div>
                <div>
                    <h5 class="fw-semibold mb-1">Vielseitige Anwendung</h5>
                    <p class="mb-0 text-secondary">Perfekt für Marketing, Vertrieb, Partnerschaften, Recruiting, Standortanalysen und mehr.</p>
                </div>
            </div>

            <!-- Erweiterte Datenfelder -->
            <div class="benefit-card d-flex align-items-center p-4 rounded-4 shadow-sm bg-white">
                <div class="benefit-icon me-4">
                    <!-- SVG: Data Expansion -->
                    <svg width="48" height="48" fill="none"><rect width="48" height="48" rx="24" fill="#06b6d4" fill-opacity="0.09"/><rect x="17" y="17" width="14" height="14" rx="4" fill="#06b6d4"/><path d="M21 28v-6h6v6" stroke="#fff" stroke-width="2"/><path d="M21 24h6" stroke="#fff" stroke-width="2"/></svg>
                </div>
                <div>
                    <h5 class="fw-semibold mb-1">Erweiterte Datenfelder</h5>
                    <p class="mb-0 text-secondary">Profitieren Sie von einzigartigen Features wie Social-Media-Links und firmenspezifischen Keywords, die Ihnen bei anderen Anbietern oft fehlen.</p>
                </div>
            </div>

            <!-- Flexible Filter -->
            <div class="benefit-card d-flex align-items-center p-4 rounded-4 shadow-sm bg-white">
                <div class="benefit-icon me-4">
                    <!-- SVG: Filter -->
                    <svg width="48" height="48" fill="none"><rect width="48" height="48" rx="24" fill="#a78bfa" fill-opacity="0.09"/><rect x="14" y="14" width="20" height="5" rx="2.5" fill="#a78bfa"/><rect x="19" y="25" width="10" height="5" rx="2.5" fill="#a78bfa"/></svg>
                </div>
                <div>
                    <h5 class="fw-semibold mb-1">Flexible Filter</h5>
                    <p class="mb-0 text-secondary">Sie bestimmen selbst, welche Branchen, Regionen oder Datenfelder für Sie relevant sind.</p>
                </div>
            </div>
        </div>
    </div>
</section>
